import React from 'react';
import './VisaProServices.css';

const VisaProServices = ({ onBack }) => {
    const whatsappNumber = '971589532066';
    const whatsappLink = `https://wa.me/${whatsappNumber}`;

    const services = [
        {
            title: 'Employment Visa Processing, Renewal & Cancellation',
            description: 'Streamline the process of obtaining employment visas for your workforce. We handle all documentation and approvals, ensuring quick and hassle-free issuance.'
        },
        {
            title: 'Investor & Partner Visas',
            description: 'Secure investor or partner visas for business owners and stakeholders with ease, allowing you to focus on your enterprise.'
        },
        {
            title: 'Family Visa Services',
            description: 'Bring your loved ones to the UAE with our efficient family visa application and sponsorship services.'
        },
        {
            title: 'Trade License Services',
            description: 'Assistance with issuing, renewing, and amending trade licenses to keep your business operational and compliant.'
        },
        {
            title: 'Document Clearing & Attestation',
            description: 'We manage all government document attestations, notarizations, and legal translations to ensure accuracy and compliance.'
        },
        {
            title: 'Government Approvals',
            description: 'Fast-tracking approvals from government entities like DED, immigration, and labor departments, saving you from delays and complications.'
        }
    ];

    const clientGoals = [
        'Hassle-free visa processing',
        'Cost-effective documentation solutions',
        'Streamlined government approvals'
    ];

    return (
        <div className="visa-page">
            <header className="visa-header">
                <button className="visa-back-btn" onClick={onBack} aria-label="Back to home">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="19" y1="12" x2="5" y2="12"/>
                        <polyline points="12 19 5 12 12 5"/>
                    </svg>
                    <span>Back</span>
                </button>
            </header>

            <section
                className="visa-hero"
                style={{
                    backgroundImage: `linear-gradient(rgba(15, 20, 25, 0.85), rgba(15, 20, 25, 0.85)), url('https://media.licdn.com/dms/image/v2/D4D12AQGkdCNCXeycAQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1722964894211?e=1786579200&v=beta&t=sxsbK00sLyvshRVipHfJzw76Q6FMnqM1HQaBqlHK9pI')`
                }}
            >
                <div className="visa-container">
                    <h1 className="visa-hero-title">Visa & PRO Services</h1>
                    <p className="visa-hero-subtitle">Simplifying Government Processes, Empowering Your Business</p>
                </div>
            </section>

            <section className="visa-section">
                <div className="visa-container visa-intro-grid">
                    <div className="visa-intro-image-wrapper">
                        <img
                            src="/assets/visa-pro-1.jpg"
                            alt="Business professionals reviewing documents"
                            className="visa-intro-image"
                        />
                    </div>
                    <p className="visa-intro">
                        At Aroha, we specialize in providing seamless Visa & PRO Services to businesses
                        and individuals throughout the UAE. Our expert team ensures efficient handling
                        of all government-related processes, saving you time, effort, and money.
                        Whether you're a new business or an established company, our services are
                        designed to meet your specific needs and ensure compliance with UAE regulations.
                    </p>
                </div>
            </section>

            <section className="visa-section visa-section-alt">
                <div className="visa-container">
                    <h2 className="visa-section-title">Our Visa & PRO Services Include</h2>
                    <div className="visa-services-grid">
                        {services.map((service, index) => (
                            <div key={index} className="visa-service-card">
                                <h3 className="visa-service-title">{service.title}</h3>
                                <p className="visa-service-description">{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="visa-section">
                <div className="visa-container visa-background-grid">
                    <div>
                        <h2 className="visa-section-title visa-section-title-left">Client Background</h2>
                        <p className="visa-intro visa-intro-left">
                            Our clients approach Aroha to overcome challenges in managing visa applications
                            and trade license renewals while ensuring compliance with UAE regulations.
                        </p>
                        <h3 className="visa-goals-title">Client Goals</h3>
                        <ul className="visa-goals-list">
                            {clientGoals.map((goal, index) => (
                                <li key={index}>{goal}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="visa-background-image-wrapper">
                        <img
                            src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=700&fit=crop"
                            alt="Skyline representing UAE business landscape"
                            className="visa-background-image"
                        />
                    </div>
                </div>
            </section>

            <section className="visa-cta">
                <div className="visa-container">
                    <h2 className="visa-cta-title">Get Started Today</h2>
                    <p className="visa-cta-text">
                        Let Aroha handle your Visa & PRO Services while you focus on growing your business.
                    </p>

                    <a
                        href={whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="visa-whatsapp-btn"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                            <path d="M12.001 2C6.478 2 2 6.478 2 12c0 1.821.487 3.53 1.338 5.002L2.06 22l5.147-1.253A9.945 9.945 0 0012.001 22c5.523 0 10-4.478 10-10S17.524 2 12.001 2zm0 18.184a8.157 8.157 0 01-4.166-1.14l-.298-.177-3.097.754.767-3.026-.194-.31A8.163 8.163 0 013.834 12c0-4.508 3.667-8.184 8.167-8.184 4.5 0 8.166 3.676 8.166 8.184 0 4.508-3.666 8.184-8.166 8.184z"/>
                        </svg>
                        <span>Contact Us on WhatsApp</span>
                    </a>
                </div>
            </section>
        </div>
    );
};

export default VisaProServices;